module.exports = __webpack_public_path__ + "img/civil.9cb6a37a.jpg";